import React from "react";
import { articles } from "../articals/articles";
import ArticlesCard from "./ArticlesCard";

const ArticlesSection = () => {
    return (
        <section
            id="articles"
            className="py-24 bg-white dark:bg-surface-dark border-t border-gray-100 dark:border-gray-800 scroll-mt-20 overflow-hidden"
        >
            <div className="w-[90%] mx-auto">
                {/* Section Header */}
                <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
                    <div className="reveal max-w-xl">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-widest font-display mb-4">
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                            </span>
                            Thoughts & Insights
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-[#0d121b] dark:text-white font-display tracking-tight">
                            Recent Writing
                        </h2>
                    </div>

                    {/* Right Side: Description & Link */}
                    <div className="reveal reveal-delay-1 flex flex-col items-start md:items-end gap-6 max-w-sm">
                        <p className="text-gray-500 dark:text-gray-400 text-sm md:text-right leading-relaxed font-medium">
                            Exploring <span className="text-primary">AI</span>, SaaS, and creativity through music & travel.
                        </p>



                        <a
                            href="/blog"
                            className="hidden md:flex items-center gap-2 text-primary font-bold text-xs uppercase tracking-[0.2em] group"
                        >
                            View All Articles
                            <span className="material-symbols-outlined text-lg group-hover:translate-x-1 transition-transform">
                                arrow_right_alt
                            </span>
                        </a>
                    </div>
                </div>

                {/* Articles Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {articles.slice(0, 4).map((article, index) => (
                        <ArticlesCard
                            key={article.id}
                            article={article}
                            delay={`reveal-delay-${(index % 4) + 1}`}
                        />
                    ))}
                </div>

                {/* Mobile View All Button */}
                <div className="mt-12 flex justify-center md:hidden">
                    <a
                        href="/blog"
                        className="px-8 py-4 rounded-2xl bg-primary/10 text-primary font-bold text-xs uppercase tracking-widest hover:bg-primary hover:text-white transition-all shadow-sm"
                    >
                        See Everything
                    </a>
                </div>
            </div>
        </section>
    );
};

export default ArticlesSection;